import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Linkedin',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { width: "24", height: "24", viewBox: "0 5 24 24", xmlns: "http://www.w3.org/2000/svg" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "M2 9.664c0-.643.225-1.174.676-1.593.45-.418 1.036-.627 1.756-.627.708 0 1.281.206 1.719.618.45.424.675.978.675 1.66 0 .618-.219 1.133-.656 1.544-.451.425-1.043.637-1.776.637h-.019c-.708 0-1.281-.212-1.719-.637C2.219 10.842 2 10.308 2 9.664Zm.251 16.892V13.66h4.286v12.896H2.251Zm6.66 0h4.286v-7.201c0-.45.051-.798.154-1.042a2.8 2.8 0 0 1 .821-1.11c.367-.303.827-.454 1.38-.454 1.442 0 2.162.972 2.162 2.915v6.892H22v-7.394c0-1.905-.45-3.349-1.351-4.334-.901-.984-2.092-1.477-3.572-1.477-1.66 0-2.953.715-3.88 2.143v.039h-.019l.019-.039V13.66H8.911c.026.412.039 1.693.039 3.842s-.013 5.167-.039 9.054Z" }
      })]
    );
  }
};